/**
 * Single source of truth for region values and their display labels.
 *
 * Add new regions here — HOMEPAGE_REGIONS (shared/seo.ts) and REGION_LABELS
 * (client/src/lib/regionLabels.ts) are derived from this map automatically,
 * so the filter and the labels can never drift apart.
 */
export const REGION_MAP = {
  Albany: "Albany",
  Troy: "Troy",
  Schenectady: "Schenectady",
  Saratoga: "Saratoga",
} as const satisfies Record<string, string>;

/** Union of all known region keys, e.g. "Albany" | "Troy" | ... */
export type RegionKey = keyof typeof REGION_MAP;

/** Ordered tuple of region keys for use in filters and SEO configs. */
export const REGION_KEYS = Object.keys(REGION_MAP) as ReadonlyArray<RegionKey>;
